import { render, staticRenderFns } from "./PromotionsMechanism.vue?vue&type=template&id=6b6a7a1e&scoped=true"
import script from "./PromotionsMechanism.vue?vue&type=script&lang=js"
export * from "./PromotionsMechanism.vue?vue&type=script&lang=js"
import style0 from "./PromotionsMechanism.vue?vue&type=style&index=0&id=6b6a7a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a7a1e",
  null
  
)

export default component.exports